/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "563bb05434856ebf59013d18143fa11ab2a16ebc";
